import React from 'react';
import { modules, promises, systemIntro } from '../data/modules';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME, PRODUCT_SUBTITLE } from './constants';
export function SystemSection() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-125" data-mp="3bhtzv4urfu0h">
      <div className="mx-auto max-w-4xl" data-id="element-126" data-mp="36jsfmglllonf">
        <div className="mb-2 text-center" data-id="element-127" data-mp="36iqvznqintu3">
          <p className="mb-0.5 font-display text-[10.5px] font-bold uppercase tracking-[0.16em] text-eq-gold sm:text-sm" data-id="element-128" data-mp="36m68cist2ort">
            The Complete System You’ve Been Looking For
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-129" data-mp="2wrw6mahz4e4f">
            One Complete 6-in-1 Riding Instruction System
          </h2>
          <div className="mb-1 inline-block rounded-md border border-eq-gold/70 bg-eq-navy px-3 py-1.5 shadow-md" data-id="element-130" data-mp="2nr7qna90s3ow">
            <p className="font-display text-[15px] font-extrabold uppercase leading-none tracking-tight text-white sm:text-2xl" data-id="element-131" data-mp="2iw26afv9mx2x">
              {PRODUCT_NAME}
            </p>
            <p className="font-display text-[10.5px] font-semibold text-eq-goldLight sm:text-sm" data-id="element-132" data-mp="13xwujbuupizv">
              {PRODUCT_SUBTITLE}
            </p>
          </div>
          <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-eq-muted sm:text-base" data-id="element-133" data-mp="u1tjfgi0ua0s">
            {systemIntro.map(line => <p key={line} data-id="element-134" data-mp="1mppn5560d272">{line}</p>)}
          </div>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-0.5 text-[11px] font-bold text-eq-navy sm:text-sm" data-id="element-135" data-mp="1mqh87m1zbhj3">
            {promises.map(promise => <li key={promise} data-id="element-136" data-mp="1cqqgfs4szgmp">✔ {promise}</li>)}
          </ul>
        </div>

        <h3 className="mb-1.5 text-center font-display text-lg font-extrabold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-137" data-mp="1hpl2r41zbnbk">
          What’s Inside
        </h3>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-138" data-mp="6b7j6be9du1c">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-2 rounded-lg border border-eq-line bg-eq-light p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-eq-gold sm:p-3" data-id="element-139" data-mp="28ymova4pwp7p">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-eq-navy font-display text-base font-extrabold leading-none text-eq-goldLight transition-colors duration-150 ease-out group-hover:bg-eq-deep" data-id="element-140" data-mp="1z5ysgghngn9i">
                {module.num}
              </span>
              <div data-id="element-141" data-mp="1l78yh9q4n3pd">
                <h4 className="font-display text-[13px] font-extrabold uppercase leading-tight text-eq-navy sm:text-base" data-id="element-142" data-mp="1g9fqqc96e1mz">
                  ✅ Module {module.num} — {module.title}
                </h4>
                {module.lines.map(line => <p key={line} className="mt-0.5 text-[12px] font-medium leading-snug text-eq-muted sm:text-sm" data-id="element-143" data-mp="3am5l0v3ghcuw">
                    {line}
                  </p>)}
              </div>
            </a>)}
        </div>

        <div className="mt-2 text-center" data-id="element-144" data-mp="3i5omqikhbust">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Go to the purchase section" data-id="element-145" data-mp="3i4mytdid7dto">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[190px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-146" data-mp="3n02bi24mz3oi" />
          </a>
        </div>
      </div>
    </section>;
}